export default "__VITE_ASSET__k2IDWLz0__"